import React, {useCallback, useContext, useState} from 'react';
import block from 'bem-cn-lite';

import {FormBlockProps} from 'units/constructor-local/models';
import YandexForm from 'components/YandexForm/YandexForm';
import {Grid, Row, Col, BlockHeader} from '@yandex-data-ui/page-constructor';
import {compose} from 'recompose';
import MobileContext from 'contexts/MobileContext';

import withFormsData, {WithFormsDataProps} from 'hoc/withFormsData';

import './Form.scss';

const b = block(' form-block');

type FormBlockInnerProps = FormBlockProps & WithFormsDataProps;

const FormBlock: React.FC<FormBlockInnerProps> = (props) => {
    const {slug, formsData} = props;
    const formData = formsData?.[slug];
    const isMobile = useContext(MobileContext);
    const [contentLoaded, setContentLoaded] = useState(false);

    const onContentLoad = useCallback(() => {
        setContentLoaded(true);
    }, []);

    if (!formsData || !formData) {
        return null;
    }

    return (
        <Grid>
            <Row>
                <Col sizes={{all: 12}}>
                    <div className={b({hidden: !contentLoaded})} data-attr={formData.slug}>
                        {formData.title && (
                            <BlockHeader
                                title={{text: formData.title, textSize: 's'}}
                                className={b('title', {mobile: isMobile})}
                                colSizes={{all: 12}}
                            />
                        )}
                        <YandexForm
                            id={formData.hash}
                            className={b('form-wrapper')}
                            onLoad={onContentLoad}
                            containerId={formData.hash}
                        />
                    </div>
                </Col>
            </Row>
        </Grid>
    );
};

export default compose<FormBlockInnerProps, FormBlockProps>(withFormsData)(FormBlock);
